import React from 'react';
import carFrontSvg from '../../assets/icons/sedan-car-front-svgrepo-com.svg';

interface CarFrontIconProps {
  size?: number;
  className?: string;
}

const CarFrontIcon: React.FC<CarFrontIconProps> = ({ size = 48, className = '' }) => {
  return (
    <img 
      src={carFrontSvg} 
      alt="Car Front Icon"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default CarFrontIcon;
